<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<template>
  <div>
    <el-dialog
      width="60%"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      @close="hide"
      append-to-body
      center
    >
      <div class="gaode-map-selector-wrapper">
        <el-select
          class="address-selector"
          v-model="selectedAddress"
          placeholder="请输入地址"
          filterable
          remote
          :remote-method="debounceSearch"
          :loading="loadingAddressList"
          @change="onAddressSelectChange"
        >
          <el-option
            v-for="item in addressOptions"
            :key="item.id"
            :label="item.address"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <div :id="mapContainerId" class="map-container"></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="hide">取 消</el-button>
        <el-button type="primary" @click="onConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <div @click="show" class="w100"><slot></slot></div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import { debounce, get } from "lodash-es";

window._AMapSecurityConfig = {
  securityJsCode: "f583e89b24c58bae431a95c3111e49fe",
};

export default {
  props: {
    // 当前是否查看详情，默认否
    disabled: {
      type: Boolean,
      default: false,
    },
    mapContainerId: {
      type: String,
      default: "mapContainer",
    },
    dialogTitle: {
      type: String,
      default: "选择地址",
    },
    defaultLatitude: {
      type: String,
      default: "",
    },
    defaultLongitude: {
      type: String,
      default: "",
    },
    defaultAddress: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: false,
      // 地图实例
      map: null,
      // 正在加载地图可选项
      loadingAddressList: false,
      // 地图搜索实例
      autoCompleteInstance: null,
      // 模糊可选地址
      addressOptions: [],
      // 当前选中的地址
      selectedAddress: "",
      // 地图上的点标记
      marker: null,
      // 当前选中的地址对象
      currentSelectedAddressObj: null,
      // 防抖搜索
      debounceSearch: debounce(this.loadAddressRemote, 500),
    };
  },
  methods: {
    // 确认选择地址
    onConfirm() {
      // 对外抛出选中的地址对象
      this.$emit("confirm", this.currentSelectedAddressObj);
      this.hide();
    },
    onAddressSelectChange(addressId) {
      // 根据地址id选中地址
      this.currentSelectedAddressObj =
        this.addressOptions.find((item) => item.id === addressId) || null;
      if (this.currentSelectedAddressObj) {
        // 选中之后，设置地图中心点
        this.map.setCenter([
          this.currentSelectedAddressObj.lng,
          this.currentSelectedAddressObj.lat,
        ]);
        // 添加红点
        this.addMarker([
          this.currentSelectedAddressObj.lng,
          this.currentSelectedAddressObj.lat,
        ]);
      }
    },
    /**
     * 初始化地图
     * 1. 使用AMapLoader把地图库资源加载过来
     * 2. 库加载完成后，初始化地图实例
     */
    initMap() {
      return AMapLoader.load({
        key: "682e4749bde4d4bd298ef68f924c9d22", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JS API 的版本，缺省时默认为 1.4.15
        // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        plugins: ["AMap.AutoComplete"],
      }).then(() => {
        /**
         * 初始化地图实例
         * load完成后，window上就挂载好了AMap对象，可直接使用
         */
        this.map = new window.AMap.Map(this.mapContainerId, {
          zoom: 14,
        });
      });
    },
    // 获取可选地址
    loadAddressRemote(keywords) {
      if (keywords !== "") {
        // 实例化一次搜索即可
        if (!this.autoCompleteInstance) {
          // 实例化搜索
          this.autoCompleteInstance = new window.AMap.AutoComplete({
            pageIndex: 1,
            pageSize: 10,
          });
        }
        this.loadingAddressList = true;
        this.autoCompleteInstance.search(keywords, (status, result) => {
          this.loadingAddressList = false;
          let options = [];
          if (status === "complete") {
            // 高德 Tip 对象 文档：https://lbs.amap.com/api/javascript-api/reference/search/#m_Tip
            options = result.tips;
          }
          this.addressOptions = options.map((item) => {
            const district = get(item, "district", "");
            const address = get(item, "address", "");
            const name = get(item, "name", "");
            const lng = get(item, ["location", "lng"], "");
            const lat = get(item, ["location", "lat"], "");
            return {
              // 使用经纬度拼接一个id
              id: `${lng}-${lat}`,
              address: `${district}${address}${name}`,
              // 经度
              lng,
              // 维度
              lat,
            };
          });
        });
      } else {
        this.addressOptions = [];
      }
    },
    // 往地图上添加点标记
    addMarker(position) {
      let marker = this.marker;
      if (!this.marker) {
        marker = new window.AMap.Marker({
          icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png",
          offset: new window.AMap.Pixel(-13, -30),
        });
      }
      marker.setPosition(position); // 设置点标记的经纬度位置
      this.marker = marker;
      this.map.add(marker);
    },
    setDefaultSelectedAddress(options) {
      this.map.setCenter(options.center);
      this.addMarker(options.center);
      const optionItem = {
        id: options.center.join("-"),
        address: options.address,
        lng: options.center[0],
        lat: options.center[1],
      };
      this.addressOptions = [optionItem];
      this.currentSelectedAddressObj = optionItem;
    },
    show() {
      console.log("show");
      if (this.disabled) return;
      this.dialogVisible = true;
      this.currentSelectedAddressObj = null;
      // 调用初始化地图的方法
      setTimeout(() => {
        this.initMap().then(() => {
          // 如果外部传入了值，则直接设置地图中心点
          if (
            this.defaultLatitude &&
            this.defaultLongitude &&
            this.defaultAddress
          ) {
            const options = {
              center: [this.defaultLongitude, this.defaultLatitude],
              address: this.defaultAddress,
            };
            this.setDefaultSelectedAddress(options);
          }
        });
      }, 1000);
    },
    hide() {
      if (this.map) {
        this.selectedAddress = "";
        this.map.destroy(); // 销毁地图实例
        this.map = null;
      }
      this.dialogVisible = false;
      this.autoCompleteInstance = null;
      this.marker = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.address-selector {
  width: 100%;
  margin-bottom: 20px;
}
.map-container {
  width: 100%;
  height: 500px;
}
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
</style>
